<template>
  <div class="jj_con">
    <el-col :xs="24" :sm="24" :md="18" :lg="18" :xl="18" v-html="body">

    </el-col>
    <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6" class="text-center">
      <img src="../../assets/images/qk_pic.gif" />
    </el-col>
    <div class="clearfix"></div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            body:""
        }
    },
    mounted(){
        this.getBody()
    },
    methods:{
        getBody(){
            let params=[1100]
        this.$store.dispatch("_getHeader",params).then(res=>{
          this.body=res.data.Data[0].Body
      }).catch(err=>{
          console.log(err)
      })
    }
    }
};
</script>